






















































import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Home = namespace("home");
const Theme = namespace("theme");

@Component({})
export default class PreviousPageArrow extends Vue {
  @Theme.Getter("getAccentColor") accentColor!: string;
  @Home.Action("promptForCancel") promptForCancel!: (
    isCancelling: boolean
  ) => void;
  @Prop({ default: true }) isDarkBackground!: boolean;
  @Prop({ default: true }) showPrevious!: boolean;

  confirmPromptForCancel() {
    this.promptForCancel(true);
  }
}
